/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteAccountDraftRequest
 */
export interface CompleteAccountDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof CompleteAccountDraftRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteAccountDraftRequest
     */
    lastName: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompleteAccountDraftRequest
     */
    areTermsAndConditionsAccepted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompleteAccountDraftRequest
     */
    isOptedInToMarketingEmails: boolean;
}

/**
 * Check if a given object implements the CompleteAccountDraftRequest interface.
 */
export function instanceOfCompleteAccountDraftRequest(value: object): value is CompleteAccountDraftRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('areTermsAndConditionsAccepted' in value) || value['areTermsAndConditionsAccepted'] === undefined) return false;
    if (!('isOptedInToMarketingEmails' in value) || value['isOptedInToMarketingEmails'] === undefined) return false;
    return true;
}

export function CompleteAccountDraftRequestFromJSON(json: any): CompleteAccountDraftRequest {
    return CompleteAccountDraftRequestFromJSONTyped(json, false);
}

export function CompleteAccountDraftRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteAccountDraftRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'areTermsAndConditionsAccepted': json['areTermsAndConditionsAccepted'],
        'isOptedInToMarketingEmails': json['isOptedInToMarketingEmails'],
    };
}

export function CompleteAccountDraftRequestToJSON(value?: CompleteAccountDraftRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'areTermsAndConditionsAccepted': value['areTermsAndConditionsAccepted'],
        'isOptedInToMarketingEmails': value['isOptedInToMarketingEmails'],
    };
}

